import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			purchase_date:"",
			purchase_folio:"",
			entry_date:"",
			provider:"",
			distributor:"",
			details:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(item){

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'supplies_purchase/'+item.purchase.id,{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show: true,
					purchase_date:item.purchase.purchase_date,
					purchase_folio:item.purchase.purchase_folio,
					entry_date:item.purchase.entry_date,
					provider:item.provider,
					distributor:item.distributor,
					details:response.detail
				});
			}
		})			
	}

	handleClose(){
		this.setState({
			show: false,
			entry:[],
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Entrada</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Fabricante</span>
		        				<input type="text" className="form-control" value={this.state.provider} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.distributor} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">F. Entrada</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.entry_date !== "" ? moment(this.state.entry_date).format('DD/MM/YYYY') : ""} />
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Folio Factura</span>
		        				<input type="text" className="form-control" value={this.state.purchase_folio || ""} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">F. Factura</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.purchase_date !== "" ? 
		        						moment(this.state.purchase_date).format('DD/MM/YYYY') : ""} />
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			
		        			<Table responsive hover>
		        				<thead>
				                  	<tr>
				                  		<th>Insumo</th>
					                    <th>Lote</th>
					                    <th>Fecha Caducidad</th>
					                    <th>Cantidad</th>
										<th>Temperatura</th>
					                    <th>Costo</th>
				                  	</tr>
				                </thead>
				                <tbody>
				                 	{this.state.details.map( (d, index) => (
				                    	<tr key={index}>
				                    		<td>{d.name}</td>
				                      		<td>{d.lot_number}</td>
						                    <td>{d.expiration_date ==null ? "":moment(d.expiration_date).format('DD/MM/YYYY')}</td>
						                    <td>{d.amount}</td>
						                    <td>{d.temperature}</td>
											<td>{d.cost_unit_entry !== null ? '$ '+d.cost_unit_entry.toFixed(2) : ''}</td>
				                    	</tr>
				                  	))}
				                </tbody>
		        			</Table>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
} 

export default translate('translations') (ModalDetails);